import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorTestHttpService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getError(errorCode: number): Observable<any> {
    const url = `${this.baseUrl}testerror/${errorCode}`;
    return this.http.get<any>(url);
  }
}
